/* eslint-disable no-underscore-dangle */
import React, { Component, Fragment } from 'react';
import _ from 'lodash';
import ultilitiesService from 'shared/util/ultilitiesService';
import { animateScroll as scroll } from 'react-scroll';
import baseUrl from 'shared/util/baseUrl';
import {
  Step, Button, BottomButton, BotTyping,
} from 'components';
// import step1Background from 'assets/images/heroGraphic.png';
// import step2Background from 'assets/images/heroInvestorProfile.png';
// import step3Background from 'assets/images/heroInvestmentPreference.png';
import arrow from 'assets/icons/next.svg';
import arrowWhite from 'assets/icons/nextWhite.svg';
import './JourneyOverview.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import { LayoutWithBannerNavbar } from 'layouts';
import { getRTL } from 'shared/redux/selectors';
import {
  PATH,
  STATUS,
  WEBSOCKET_STATUS_CONNECTED,
  // WEBSOCKET_TIMEOUT_SECONDS,
  // WEBSOCKET_STATUS_CLOSED,
  // WEBSOCKET_STATUS_NOT_CONNECTED,
} from 'shared/constants';
import { connect } from 'react-redux';
import {
  generateChannel, getStepStatus, toggleLanguage, websocketConnect, activateStartStep,
} from 'shared/redux/actions';
import trackEvent from 'components/TrackEvent';
import { eventInvestmentProfileStartNow } from 'components/TrackEvent/constEvent';

const statusBarClass = 'status-bar--journey';

class JourneyOverview extends Component {
  state = {
    banner: null,
  }

  componentDidMount() {
    document.body.classList.add(statusBarClass);

    const {
      userInfo,
      onGetStepStatus,
      summary,
    } = this.props;
    if (userInfo && userInfo._id) {
      if (!_.isEmpty(summary)) {
        onGetStepStatus();
      }
    }

    this.scrollToNextStep();
  }

  componentDidUpdate() {
    this.scrollToNextStep();
  }

  componentWillUnmount() {
    document.body.classList.remove(statusBarClass);
  }

  static getDerivedStateFromProps(props, state) {
    const { stepStatus } = props;
    const imgSource = {
      step1Background: `${baseUrl}/images/heroGraphic.png`,
      step2Background: `${baseUrl}/images/heroInvestorProfile.png`,
      step3Background: `${baseUrl}/images/heroInvestmentPreference.png`,
    };
    const bg = [imgSource.step1Background, imgSource.step2Background, imgSource.step3Background];
    const currentActive = stepStatus.find(item => item.active === true && item.status !== STATUS.COMPLETED);

    if (!currentActive) {
      return {
        banner: bg[2],
      };
    }

    return {
      banner: bg[currentActive.number - 1],
    };
  }

  /**
   * Auto scroll to step 3 on smaller screen
 */
  scrollToNextStep = () => {
    const step3 = document.querySelector('.nw-step-2');
    if (step3 && step3.classList.contains('nw-step--incompleted')) {
      scroll.scrollTo(document.querySelectorAll('.nw-step--incompleted')[0].offsetTop, {
        duration: 800,
        containerId: 'page-body',
        delay: 0,
        smooth: 'linear',
      });
    }
  }

  goBack = () => {
    const { history } = this.props;
    history.push(PATH.HOME);
  };

  getNavTitle = () => {
    const { stepStatus } = this.props;
    const isComplete = stepStatus.filter(item => item.status === STATUS.COMPLETED).length;
    const isInComplete = stepStatus.filter(item => item.status === STATUS.INCOMPLETE).length;
    if (isComplete === stepStatus.length) {
      return 'journey.reviewInvestment';
    }

    if (isComplete > 0 || isInComplete > 0) {
      return 'journey.continueInvestment';
    }

    return 'journey.startInvestment';
  };

  render() {
    const {
      // currentStep,
      redo,
      onGenerateChannel,
      stepStatus,
      currentLocale,
      history,
      websocketStatus,
      onActivateStartStep,
      isRtl,
      intl
    } = this.props;


    const allStepCompleted = stepStatus.filter(item => item.status === STATUS.COMPLETED).length === stepStatus.length;

    return (
      <LayoutWithBannerNavbar
        title={this.getNavTitle()}
        leftButton={(<span className="arrow"><img src={arrowWhite} alt="arrow" /></span>)}
        onLeftClick={this.goBack}
        rightButton={ultilitiesService.locale(currentLocale)}
        onRightClick={() => history.push(PATH.LANGUAGE)}
        background={this.state.banner}
        className="nw-page-journey"
        isRtl={isRtl}
      >
        { _.isEmpty(stepStatus) && <BotTyping alwaysShow /> }
        {!_.isEmpty(stepStatus) && stepStatus.map((item, i) => (
          <Step
            customClass={`nw-step-${i}`}
            currentLocale={currentLocale}
            key={item.step}
            number={i + 1}
            isActive={item.active}
            title={item.title}
            description={item.desc}
            status={item.status}
            isDisabled={!!(redo && item.step !== redo) || (websocketStatus !== WEBSOCKET_STATUS_CONNECTED)}
            onButtonClick={() => {
              // activate the status that the user has already start the steps
              onActivateStartStep();

              onGenerateChannel();
              this.props.history.push({
                pathname: item.path,
                state: { isRedo: item.status === STATUS.COMPLETED, isResume: item.status === STATUS.INCOMPLETE },
              });
              if (item.status !== STATUS.COMPLETED && item.status !== STATUS.INCOMPLETE) {
                switch (i) {
                  case 0: 
                    trackEvent(eventInvestmentProfileStartNow(currentLocale, intl.formatMessage({ id: 'journey.start' })));
                    break;
                  default:
                    break;
                }
              }
            }}
          />
        ))}
        {
          !_.isEmpty(stepStatus)
              && (
              <>
                {allStepCompleted
                  ? (
                    <BottomButton
                      value={<FormattedMessage id="journey.investmentSummary" />}
                      isPrimary
                      onButtonClick={() => this.props.history.push(PATH.INVESTMENT_SUMMARY)}
                    />
                  )
                  : (
                    <section className="center">
                      <Button
                        value={(
                          <Fragment>
                            <FormattedMessage id="journey.learnMore" />
                            <span className="arrow"><img src={arrow} alt="Icon arrow next" /></span>
                          </Fragment>
                              )}
                        isLink
                        rtl={isRtl}
                        onButtonClick={() => this.props.history.push(PATH.ABOUT_INVESTMENT_ADVICE)}
                      />

                    </section>
                  )
                }
              </>
              )
        }
      </LayoutWithBannerNavbar>
    );
  }
}

const mapStateToProps = ({ rootReducer }) => ({
  stepStatus: rootReducer.stepStatus,
  websocketStatus: rootReducer.websocketStatus,
  userInfo: rootReducer.userInfo,
  currentLocale: rootReducer.language.locale,
  redo: rootReducer.redo,
  summary: rootReducer.summary,
  isRtl: getRTL(rootReducer),
});

const mapDispatchToProps = ({
  onWebsocketConnect: websocketConnect,
  onGenerateChannel: generateChannel,
  onGetStepStatus: getStepStatus,
  onSwitchLanguage: toggleLanguage,
  onActivateStartStep: activateStartStep,
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(JourneyOverview));
